module.exports = __webpack_public_path__ + "img/ma-icon.eb3ed88f.png";